module.exports = __webpack_public_path__ + "static/media/insert_tag.dbca2efd.png";